import * as React from "react";
import "./index.scss";
import { imageBaseUrl } from "../utils/variables";
export var OptionCard = function (props) {
    return (React.createElement("div", { className: "option-card shadow", onClick: function () { return props.onClick(); } },
        React.createElement("div", { className: "content-container" },
            React.createElement("div", { className: "text-box" },
                React.createElement("div", { className: "primary-text" }, props.primaryText),
                props.secondaryText &&
                    React.createElement("div", { className: "secondary-text" }, props.secondaryText)),
            React.createElement("div", { className: "icon" },
                React.createElement("img", { src: "".concat(imageBaseUrl, "/img/consent/option_card_circle.png"), alt: "Next" })))));
};
export default OptionCard;
//# sourceMappingURL=index.js.map